"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const client_1 = require("react-dom/client");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const project_config_1 = __importDefault(require("evolution-common/lib/config/project.config"));
const i18n_config_1 = __importDefault(require("../../config/i18n.config"));
const AdminSurveyRouter_1 = __importDefault(require("../../components/admin/routers/AdminSurveyRouter"));
const configureStore_1 = require("../../store/configureStore");
const LoadingPage_1 = __importDefault(require("chaire-lib-frontend/lib/components/pages/LoadingPage"));
const InterviewContext_1 = require("../../contexts/InterviewContext");
const SurveyContext_1 = require("../../contexts/SurveyContext");
const application_config_1 = __importStar(require("chaire-lib-frontend/lib/config/application.config"));
require("../../styles/survey/styles-admin-survey.scss");
const verifyAuthentication_1 = __importDefault(require("chaire-lib-frontend/lib/services/auth/verifyAuthentication"));
const TripsAndSegmentsSection_1 = __importDefault(require("../../components/survey/sectionTemplates/TripsAndSegmentsSection"));
// TODO This is a workaround to get the links to the user, until some more complete solution is implemented (see https://github.com/chairemobilite/transition/issues/1516)
const pages = [
    { path: '/admin/validation', permissions: { Interviews: ['validate'] }, title: 'admin:validationPageTitle' },
    { path: '/admin/monitoring', permissions: { Interviews: ['manage'] }, title: 'admin:monitoringPageTitle' },
    { path: '/admin/users', permissions: { Users: ['read', 'update'] }, title: 'admin:usersPageTitle' }
];
(0, application_config_1.setApplicationConfiguration)({
    homePage: '/home',
    pages,
    templateMapping: { tripsAndSegmentsWithMap: TripsAndSegmentsSection_1.default }
});
exports.default = () => {
    document.title = project_config_1.default.title[i18n_config_1.default.language];
    const store = (0, configureStore_1.configureStore)();
    const Jsx = () => {
        const [state, dispatch] = react_1.default.useReducer(InterviewContext_1.interviewReducer, InterviewContext_1.initialState);
        const [devMode, dispatchSurvey] = react_1.default.useReducer(SurveyContext_1.surveyReducer, { devMode: false });
        const router = react_1.default.useMemo(() => (0, react_router_1.createBrowserRouter)((0, AdminSurveyRouter_1.default)()), []);
        return (react_1.default.createElement(SurveyContext_1.SurveyContext.Provider, { value: Object.assign(Object.assign({ sections: application_config_1.default.sections, widgets: application_config_1.default.widgets }, devMode), { dispatch: dispatchSurvey }) },
            react_1.default.createElement(InterviewContext_1.InterviewContext.Provider, { value: { state, dispatch } },
                react_1.default.createElement(react_redux_1.Provider, { store: store },
                    react_1.default.createElement(react_i18next_1.I18nextProvider, { i18n: i18n_config_1.default },
                        react_1.default.createElement(react_router_1.RouterProvider, { router: router }))))));
    };
    let hasRendered = false;
    const root = (0, client_1.createRoot)(document.getElementById('app'));
    const renderApp = () => {
        if (!hasRendered) {
            root.render(react_1.default.createElement(Jsx, null));
            hasRendered = true;
        }
    };
    root.render(react_1.default.createElement(LoadingPage_1.default, null));
    (0, verifyAuthentication_1.default)(store.dispatch).finally(() => renderApp());
};
//# sourceMappingURL=index.js.map